const urlAppendTimestamp = (url: string): string => `${url}?_d=${Date.now()}`;

export default urlAppendTimestamp;
